export type DragPosition = 'top' | 'bottom' | null;

export type DragItem = {
    index: number;
};

export const DEFAULT_TYPE = 'DRAGGABLE_LIST_ITEM';
